/**
 * /platform/roles/new - wraps RoleEditor in create mode.
 *
 * On save, ``RoleEditor`` navigates to the new role's detail page;
 * the cancel button returns to /platform/roles.
 */

import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import { RoleEditor } from "@/components/RoleEditor";
import { usePageTitle } from "@/lib/use-page-title";

export function RoleNewPage(): JSX.Element {
  usePageTitle("New role");
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <Link
        to="/platform/roles"
        className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3 w-3" />
        Back to roles
      </Link>
      <RoleEditor mode={{ kind: "create" }} onCancel={() => navigate("/platform/roles")} />
    </div>
  );
}
